import PropTypes from 'prop-types';
import {useDisplaySettings} from 'src/hooks/use-display-settings';
import {useSections} from './config';
import {HorizontalLayout} from './horizontal-layout';
import {VerticalLayout} from './vertical-layout';

export const Layout = (props) => {
  const settings = useDisplaySettings();
  const sections = useSections();

  if (settings.layout === 'horizontal') {
    return (
      <HorizontalLayout
        sections={sections}
        navColor={settings.navColor}
        {...props} />
    );
  }

  return (
    <VerticalLayout
      sections={sections}
      navColor={settings.navColor}
      {...props} />
  );
};

Layout.propTypes = {
  children: PropTypes.node
};
